<div class="container-datos-personales-pension">
  <app-boton-volver (clickVolver)="goBack()"></app-boton-volver>
  <h1 class="title-section title">Solicitud de pensión por vejez</h1>

  <p id="tramite" class="sub-title">
      Revisa con atención la información que tenemos sobre ti</p>

    <h2 class="sub-title mt24">Datos personales</h2>
    <!-- Datos personales 1 -->
    <div id="datosPersonales" class="div-personal-data">
      <div class="div-data">
        <ion-text class="descripcion">Nombre:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.name">
            {{ personalData?.name || "Aún no registras tu nombre" }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
      <div class="div-data">
        <ion-text class="descripcion">Apellido:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.lastName">
            {{ personalData?.lastName || "Aún no registras tu apellido" }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
      <div class="div-data">
        <ion-text class="descripcion">Rut:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.rut">
            {{ personalData?.rut || "Aún no registras tu rut" }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
      <div class="div-data">
        <ion-text class="descripcion">Sexo:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.gender">
            {{ personalData?.gender || "Aún no registras tu sexo" }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
      <div class="div-data">
        <ion-text class="descripcion">Fecha de nacimiento:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.birthDate">
            {{
            personalData?.birthDate ||
            "Aún no registras tu fecha de nacimiento"
            }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
      <div class="div-data">
        <ion-text class="descripcion">Estado civil:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.civilStatus">
            {{
            personalData?.civilStatus || "Aún no registras tu estado civil"
            }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
    </div>

    <p class="sub-div-text mt24">
      Puedes editar estos datos agendando una
      <button type="button" class="link" (click)="goToVideoAtencion()">
        Video Atención.
      </button>
    </p>

    <!-- Datos personales 2 -->
    <h2 class="sub-title mt24">Datos de contacto</h2>
    <div class="div-personal-data">
      <div class="div-data">
        <ion-text class="descripcion">Domicilio:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.address">
            {{ personalData?.address || "Aún no registras tu domicilio" }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
      <div class="div-data">
        <ion-text class="descripcion">Teléfono:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.phoneNumber">
            {{
            personalData?.phoneNumber
            ? "+569" + personalData.phoneNumber
            : "Aún no registras tu teléfono"
            }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
      <div class="div-data">
        <ion-text class="descripcion">Correo:</ion-text>
        <ng-container *ngIf="!loadingPersonalData">
          <ion-text class="value" [class.sinRegistro]="!personalData?.email">
            {{ personalData?.email || "Aún no registras tu correo" }}
          </ion-text>
        </ng-container>
        <ion-skeleton-text *ngIf="loadingPersonalData" animated></ion-skeleton-text>
      </div>
    </div>

    <p class="sub-div-text mt24">
      Si deseas actualizar esta información, puedes hacerlo en
      <button type="button" class="link" (click)="goToYourData()">
        Tus datos.
      </button>
    </p>

    <hr class="separator-section" />

    <h2 class="sub-title mt24">Saldos obligatorios</h2>
    <ng-container
      *ngTemplateOutlet="balancesTableTemplate; context: { balances: balances }">
    </ng-container>
    <p class="sub-div-text balances-fund-change-text">
      Si deseas puedes realizar un
      <button type="button" class="link" (click)="goToFundChange()">
        Cambio de Fondos.
      </button>
    </p>

    <ng-container *ngIf="balancesVoluntario.length">
      <h2 class="sub-title mt24">Saldos voluntarios</h2>
      <ng-container
        *ngTemplateOutlet="balancesTableTemplate; context: { balances: balancesVoluntario }">
      </ng-container>
    </ng-container>

    <ng-container *ngIf="aporteEstatalRows.length">
      <h2 class="sub-title mt24">Aporte estatal APV</h2>
      <p class="sub-div-text aporte-estatal-descripcion">
        {{ textoAporteEstatalApv }}
      </p>
      <div class="balances-table-wrapper">
        <table class="balances-table balances-table--cols-3">
          <caption class="sr-only">Tabla de aporte estatal APV por fondo</caption>
          <thead>
            <tr class="balances-table__head">
              <th
                *ngFor="let header of headerAporteEstatal; let i = index"
                [ngClass]="'balances-table__col-' + (i + 1)">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="balances-table__row" *ngFor="let row of aporteEstatalRows">
              <td class="balances-table__col-1">{{ row.fund }}</td>
              <td class="balances-table__col-2 balances-table__cell--num">
                {{ row.balanceInstallments }}
              </td>
              <td class="balances-table__col-3 balances-table__cell--num">
                ${{ row.balancePesos }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mensaje-scroll-mobile">
        <icon-swipe-right></icon-swipe-right>
        Desliza hacia la derecha para revisar todo el contenido
      </div>
      <p class="balances-disclaimer">
        (*)Los montos son referenciales y podrían variar según la variación del valor cuota
      </p>
    </ng-container>

    <ng-container *ngIf="bonos.length">
      <h2 class="sub-title mt24">Bonos</h2>
      <div class="balances-table-wrapper">
        <table class="balances-table balances-table--cols-4">
          <caption class="sr-only">Tabla de bonos de reconocimiento</caption>
          <thead>
            <tr class="balances-table__head">
              <th class="balances-table__col-1">Nombre</th>
              <th class="balances-table__col-2">Estado</th>
              <th class="balances-table__col-3">Fecha de actualización</th>
              <th class="balances-table__col-4">Saldo Total*</th>
            </tr>
          </thead>
          <tbody>
            <tr class="balances-table__row" *ngFor="let bono of bonos">
              <td class="balances-table__col-1">{{ bono.bondTypeDescription }}</td>
              <td class="balances-table__col-2">{{ bono.bondStatus }}</td>
              <td class="balances-table__col-3 balances-table__cell--num">
                {{ bono.expirationDate }}
              </td>
              <td class="balances-table__col-4 balances-table__cell--num">
                ${{ bono.currentValue }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mensaje-scroll-mobile">
        <icon-swipe-right></icon-swipe-right>
        Desliza hacia la derecha para revisar todo el contenido
      </div>
      <p class="balances-disclaimer">
        (*)Los montos son referenciales y podrían variar según la variación del valor cuota
      </p>
    </ng-container>

    <ng-template #balancesTableTemplate let-balances="balances">
      <div class="balances-table-wrapper" *ngIf="balances?.length">
        <table class="balances-table balances-table--cols-4">
          <caption class="sr-only">
            Tabla de saldos por tipo de cuenta y fondo
          </caption>
          <thead>
            <tr class="balances-table__head">
              <th
                *ngFor="let header of headerBalances; let i = index"
                [ngClass]="'balances-table__col-' + (i + 1)">
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let balance of balances">
              <tr class="balances-table__row" *ngFor="let row of balance.rows; let rowIndex = index">
                <td
                  *ngIf="rowIndex === 0"
                  class="balances-table__col-1 balances-table__cell--tipo"
                  [attr.rowspan]="balance.rows.length">
                  {{ balance.accountType }}
                </td>
                <td class="balances-table__col-2">{{ row.fund }}</td>
                <td class="balances-table__col-3 balances-table__cell--num">
                  {{ row.balanceInstallments }}
                </td>
                <td class="balances-table__col-4 balances-table__cell--num">
                  ${{ row.balancePesos }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <div class="mensaje-scroll-mobile">
        <icon-swipe-right></icon-swipe-right>
        Desliza hacia la derecha para revisar todo el contenido
      </div>
      <p class="balances-disclaimer">
        (*)Los montos son referenciales y podrían variar según la variación del valor cuota
      </p>
    </ng-template>

    <!-- Beneficiarios-->
    <h2 class="sub-title mt24">Tus Beneficiarios</h2>
    <p class="sub-div-text mt24">
      Puedes agregar o modificar tus personas beneficiarias desde
      <button type="button" class="link" (click)="goToYourBeneficiaries()">
        actualizar tus beneficiarios.
      </button>
    </p>
    <div class="balances-table-wrapper">
      <table class="balances-table balances-table--cols-3 tbl-beneficiarios">
        <thead>
          <tr class="balances-table__head">
            <th *ngFor="let header of headerBeneficiaries; let i = index"
              [ngClass]="'balances-table__col-' + (i + 1)">
              {{ header }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="balances-table__row" *ngFor="let beneficiary of beneficiaries">
            <td class="balances-table__col-1 td-overflow">
              <strong>{{ beneficiary.nombre }}</strong>
            </td>
            <td class="balances-table__col-2">{{ beneficiary.parentesco }}</td>
            <td class="balances-table__col-3 td-rut">{{ beneficiary.rut }}</td>
          </tr>
        </tbody>
      </table>
      <ion-text class="beneficiarios-empty-message" *ngIf="!beneficiaries?.length">
        {{ "Aún no registras tus Beneficiarios" }}
      </ion-text>
    </div>
     <div class="mensaje-scroll-mobile">
        <icon-swipe-right></icon-swipe-right>
        Desliza hacia la derecha para revisar todo el contenido
      </div>

    <h2 class="sub-title mt24">Institución de salud</h2>
    <p class="sub-div-text-select sub-div-text-select">
      Elige la institución de salud a la que perteneces
    </p>
    <div class="div-dropdown">
      <app-dropdownlist class="mb-36 mt-12" [options]="dataDropdown"
        [placeholder]="'Selecciona tu institución de salud'" (selectedValueChange)="onChangeDropdown($event)"
        [selectedValue]="valueDropdown"></app-dropdownlist>
    </div>
    <div class="confirmacion mt24">
      <h2 class="sub-title">Para continuar, por favor confirma lo siguiente:</h2>
      <form [formGroup]="form">
        <div class="confirmacion-checks">
          <div class="info-check" *ngIf="tieneBeneficiariosHijos">
            <div class="info-check__check">
              <ion-checkbox
                slot="start"
                formControlName="checkDeclaracionSolteria"
                (ionChange)="formValueChange()"
                (keydown)="onCheckboxKeydown($event, 'checkDeclaracionSolteria')">
              </ion-checkbox>
            </div>
            <ion-label class="label-check">
              Declaración de soltería: Confirmo que los Beneficiarios (Hijo o Hija) son solteros.
            </ion-label>
          </div>
          <div class="info-check">
            <div class="info-check__check">
              <ion-checkbox slot="start" formControlName="checkData" (ionChange)="formValueChange()"
                (keydown)="onCheckboxKeydown($event)">
              </ion-checkbox>
            </div>
            <ion-label class="label-check">
              Leí con atención mis datos personales y confirmo que son correctos. Entiendo que, si algún dato es erróneo,
              mi trámite podría tener demoras.
            </ion-label>
          </div>
        </div>
      </form>
    </div>

  <div class="div-btn-continuar mt16">
    <button class="primary-button" [disabled]="btnDisabled" (click)="continue()">
      Continuar
    </button>
  </div>
</div>